var _circle, _line, _line2, _line3, _line4, _line5, _line6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAperture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-aperture",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14.31,
    y1: 8,
    x2: 20.05,
    y2: 17.94
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.69,
    y1: 8,
    x2: 21.17,
    y2: 8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 7.38,
    y1: 12,
    x2: 13.12,
    y2: 2.06
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 9.69,
    y1: 16,
    x2: 3.95,
    y2: 6.06
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 14.31,
    y1: 16,
    x2: 2.83,
    y2: 16
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 16.62,
    y1: 12,
    x2: 10.88,
    y2: 21.94
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAperture);
export default __webpack_public_path__ + "static/media/aperture.b0c7cdb753573d90a70a42dfe22af011.svg";
export { ForwardRef as ReactComponent };